import cuteCursedIcon from '@/assets/Games/Cute & Cursed/CuteCursedIcon.jpeg';
import cuteCursedFeature from '@/assets/Games/Cute & Cursed/Website/cute-cursed-feature.webp';
import wallpaperCauldronCat from '@/assets/Games/Cute & Cursed/Website/wallpaper-cauldron-cat.webp';
import wallpaperForestWitch from '@/assets/Games/Cute & Cursed/Website/wallpaper-forest-witch.webp';
import wallpaperBatCat from '@/assets/Games/Cute & Cursed/Website/wallpaper-bat-cat.webp';
import wallpaperHalloweenFriends from '@/assets/Games/Cute & Cursed/Website/wallpaper-halloween-friends.webp';
import wallpaperForestGuardians from '@/assets/Games/Cute & Cursed/Website/wallpaper-forest-guardians.webp';
import epicRiftsIcon from '@/assets/Games/Epic Rifts/Website/epic-rifts-icon.webp';
import epicRiftsHorde from '@/assets/Games/Epic Rifts/Website/epic-rifts-horde.webp';
import epicRiftsBosses from '@/assets/Games/Epic Rifts/Website/epic-rifts-bosses.webp';
import epicRiftsHunters from '@/assets/Games/Epic Rifts/Website/epic-rifts-hunters.webp';
import epicRiftsPvp from '@/assets/Games/Epic Rifts/Website/epic-rifts-pvp.webp';
import epicRiftsAbyssLord from '@/assets/Games/Epic Rifts/Website/epic-rifts-abyss-lord.webp';
import epicRiftsSkills from '@/assets/Games/Epic Rifts/Website/epic-rifts-skills.webp';
import epicRiftsGear from '@/assets/Games/Epic Rifts/Website/epic-rifts-gear.webp';
import dragonKeepIcon from '@/assets/Games/Dragon Keep - Last Stand/Website/dragon-keep-icon.webp';
import cryptKeeperIcon from '@/assets/Games/Crypt Keeper/Website/crypt-keeper-icon.webp';
import hordeTacticsIcon from '@/assets/Games/Horde Tactics/Website/horde-tactics-icon.webp';
import lastStandProtocolIcon from '@/assets/Games/Last Stand Protocol/Website/last-stand-protocol-icon.webp';
import riftHoldIcon from '@/assets/Games/Rift Hold/Website/rift-hold-icon.webp';
import soulDeskIcon from '@/assets/Games/Soul Desk/Website/soul-desk-icon.webp';

export const games = [
  {
    title: 'Cute & Cursed',
    slug: 'cute-cursed',
    monogram: 'C&C',
    description: 'An illustrated wallpaper collection with a playful, spooky edge.',
    genre: 'Wallpaper app',
    status: 'available',
    statusLabel: 'Available on Google Play',
    storeUrl: 'https://play.google.com/store/apps/details?id=com.zearloops.cutecursed&pli=1',
    image: cuteCursedIcon,
    imageAlt: 'Cute & Cursed app icon',
    heroImage: cuteCursedFeature,
    heroAlt: 'Cute & Cursed feature artwork.',
    heroWidth: 1024,
    heroHeight: 500,
    heroFit: 'cover',
    featuresHeading: 'A wallpaper collection with character',
    featuresIntro: 'Illustrated scenes bring witches, familiars, ghosts, and tiny monsters to your screen.',
    features: [
      {
        title: 'Find a scene you like',
        description: 'Browse a curated mix of characters, cozy corners, and spooky settings.'
      },
      {
        title: 'Make it your wallpaper',
        description: 'Choose artwork for your phone and give your home or lock screen a different look.'
      }
    ],
    wallpapers: [
      {
        image: wallpaperCauldronCat,
        alt: 'A witch cat stirs a glowing cauldron in a moonlit library.'
      },
      {
        image: wallpaperForestWitch,
        alt: 'A tiny dragon, a ghost, and a witch explore a glowing forest.'
      },
      {
        image: wallpaperBatCat,
        alt: 'A horned cat familiar perches among bats in a moonlit forest.'
      },
      {
        image: wallpaperHalloweenFriends,
        alt: 'A witch, small dragon, and skeleton friends gather in a forest at night.'
      },
      {
        image: wallpaperForestGuardians,
        alt: 'Chibi adventurers and knights stand before a castle in a blue-green forest.'
      }
    ]
  },
  {
    title: 'Epic Rifts',
    slug: 'epic-rifts',
    monogram: 'ER',
    description: 'Fight through 10-wave Rifts, shape a Hunter build, and face a boss at the end of each run.',
    genre: 'Action / Survival',
    status: 'coming-soon',
    statusLabel: 'Coming soon',
    image: epicRiftsIcon,
    imageAlt: 'Epic Rifts app icon showing a dragon breathing fire.',
    heroImage: epicRiftsHorde,
    heroAlt: 'Gameplay from Epic Rifts showing a Hunter fighting a wave of monsters.',
    heroWidth: 1280,
    heroHeight: 720,
    heroFit: 'contain',
    modes: [
      {
        title: 'Story Rifts',
        description: 'Survive 10 waves, adapt your build, and face a boss at the end of each Rift.',
        availability: 'Available at launch'
      },
      {
        title: 'Asynchronous PvP',
        description: 'Take on another Hunter in an auto-resolved duel and climb the rankings.',
        availability: 'Unlocks at account level 2'
      },
      {
        title: 'Abyss Heart',
        description: 'Join a shared battle against the Abyss Lord and contribute to a world boss event.',
        availability: 'Unlocks after completing Rift 2'
      },
      {
        title: 'Castle Defense',
        description: 'A strategy mode built around protecting your stronghold.',
        availability: 'Planned'
      }
    ],
    progression: [
      {
        title: '8 Hunters',
        description: 'Choose a Hunter with distinct abilities and stats.'
      },
      {
        title: '45 equipment sets',
        description: 'Mix gear bonuses to shape a build for each run.'
      },
      {
        title: 'Ranks from F to S',
        description: 'Raise a Hunter’s rank to improve stats and open skill slots.'
      }
    ],
    facts: [
      { value: '14', label: 'playable Rifts' },
      { value: '12', label: 'boss encounters' },
      { value: '20+', label: 'status effects' }
    ],
    screenshots: {
      pvp: {
        image: epicRiftsPvp,
        alt: 'Two Hunters fight on a bridge in an asynchronous PvP match.'
      },
      hunters: {
        image: epicRiftsHunters,
        alt: 'Eight colorful Hunters shown together in a lineup.'
      },
      bosses: {
        image: epicRiftsBosses,
        alt: 'A Hunter attacks a large boss during a Rift.'
      }
    },
    galleryScreenshots: [
      {
        image: epicRiftsAbyssLord,
        alt: 'Hunters gather to fight the Abyss Lord in a shared boss event.'
      },
      {
        image: epicRiftsSkills,
        alt: 'A Hunter uses powerful skills against a wave of monsters.'
      },
      {
        image: epicRiftsGear,
        alt: 'A Hunter equipment screen showing a legendary armor set and its bonuses.'
      }
    ]
  },
  {
    title: 'Dragon Keep',
    slug: 'dragon-keep',
    monogram: 'DK',
    description: 'Defend a dragon’s castle from zombie waves with three defenders, hatchling towers, and changing Auguries.',
    genre: 'Tower defense',
    status: 'planned',
    statusLabel: 'Planned',
    image: dragonKeepIcon,
    imageAlt: 'Dragon Keep game icon.',
    heroImage: dragonKeepIcon,
    heroAlt: 'Dragon Keep: Last Stand game icon.',
    heroWidth: 954,
    heroHeight: 910,
    heroFit: 'contain',
    defenders: [
      {
        title: 'Dragon Guardian',
        description: 'A permanent fire cannon covers the main approach. Llamarada strikes enemies in a full column.'
      },
      {
        title: 'Rocín',
        description: 'A flank-to-flank charge knocks zombies back from the walls, buying time for the Hatchlings.'
      },
      {
        title: 'Dragon Hatchlings',
        description: 'Place four tower types on the walls. Shadow Drake targets the zombie with the most health and applies poison that ignores armor.'
      }
    ],
    augury: 'Before each run, choose one of two random Auguries. Threat, Advantage, or Neutral modifiers change the rules for that attempt.',
    facts: [
      { value: '5', label: 'chapters' },
      { value: '50', label: 'stages' },
      { value: '3–6', label: 'minutes per run' }
    ]
  },
  {
    title: 'Crypt Keeper',
    slug: 'crypt-keeper',
    monogram: 'CK',
    description: 'Set traps and summon monsters in real time to stop four adventurers from reaching your treasure.',
    genre: 'Dungeon strategy',
    status: 'planned',
    statusLabel: 'Planned',
    image: cryptKeeperIcon,
    imageAlt: 'Crypt Keeper game icon.',
    featuresHeading: 'Protect the treasure',
    featuresIntro: 'Build a dungeon defense and react as a party of four pushes toward the vault.',
    features: [
      {
        title: 'Lay the traps',
        description: 'Place hazards through the dungeon to slow the adventurers down.'
      },
      {
        title: 'Call in monsters',
        description: 'Summon creatures in real time as the party advances.'
      },
      {
        title: 'Hold the vault',
        description: 'Stop all four adventurers before they reach the treasure.'
      }
    ]
  },
  {
    title: 'Horde Tactics',
    slug: 'horde-tactics',
    monogram: 'HT',
    description: 'Build a creature-and-spell deck, then launch asynchronous attacks against rival fortresses.',
    genre: 'Asynchronous strategy',
    status: 'planned',
    statusLabel: 'Planned',
    image: hordeTacticsIcon,
    imageAlt: 'Horde Tactics game icon.',
    featuresHeading: 'Plan the assault',
    featuresIntro: 'Horde Tactics turns tower defense around: build the attack, then send it against another player’s fortress.',
    features: [
      {
        title: 'Build a deck',
        description: 'Combine creature units and spells into an attacking force.'
      },
      {
        title: 'Choose your route',
        description: 'Send your horde through an opponent’s fortress defenses.'
      },
      {
        title: 'Attack asynchronously',
        description: 'Plan an assault without needing both players online at once.'
      }
    ]
  },
  {
    title: 'Last Stand Protocol',
    slug: 'last-stand-protocol',
    monogram: 'LSP',
    description: 'Strip defenses for escape-ship parts by day, then survive the night attacks your weakened base invites.',
    genre: 'Sci-fi survival',
    status: 'planned',
    statusLabel: 'Planned',
    image: lastStandProtocolIcon,
    imageAlt: 'Last Stand Protocol game icon.',
    featuresHeading: 'Ten days to escape',
    featuresIntro: 'Every repair brings the escape ship closer to launch—and leaves less protection for the next night.',
    features: [
      {
        title: 'Dismantle defenses',
        description: 'Trade parts of your base for the resources needed to repair the ship.'
      },
      {
        title: 'Prepare for nightfall',
        description: 'Choose what to keep defending as attacks press against the base.'
      },
      {
        title: 'Reach the final day',
        description: 'Balance survival and repairs across a ten-day countdown.'
      }
    ]
  },
  {
    title: 'RiftHold',
    slug: 'rift-hold',
    monogram: 'RH',
    description: 'Defend a Keep across roguelite waves, fuse towers, and choose relics between attacks.',
    genre: 'Roguelite tower defense',
    status: 'planned',
    statusLabel: 'Planned',
    image: riftHoldIcon,
    imageAlt: 'RiftHold game icon.',
    featuresHeading: 'Hold the bridge',
    featuresIntro: 'A tower-defense roguelite about keeping enemies away from the Keep, one run at a time.',
    features: [
      {
        title: 'Fuse towers',
        description: 'Combine defenses to strengthen the line against incoming waves.'
      },
      {
        title: 'Choose relics',
        description: 'Pick a relic between waves and adjust the plan for the next attack.'
      },
      {
        title: 'Protect the Keep',
        description: 'Hold the bridge and stop the advancing forces from reaching the stronghold.'
      }
    ]
  },
  {
    title: 'Soul Desk',
    slug: 'soul-desk',
    monogram: 'SD',
    description: 'Run an afterlife office by judging souls and sending them to Heaven, Hell, or Purgatory.',
    genre: 'Management simulation',
    status: 'planned',
    statusLabel: 'Planned',
    image: soulDeskIcon,
    imageAlt: 'Soul Desk game icon.',
    featuresHeading: 'A desk job for the afterlife',
    featuresIntro: 'Review each soul’s life, decide where it belongs, and keep the afterlife office moving.',
    features: [
      {
        title: 'Hear each case',
        description: 'Judge the souls that arrive at your desk.'
      },
      {
        title: 'Choose a destination',
        description: 'Send each soul to Heaven, Hell, or Purgatory.'
      },
      {
        title: 'Manage the office',
        description: 'Keep the afterlife’s daily work on track.'
      }
    ]
  }
];

export const gamesBySlug = games.reduce((result, game) => {
  result[game.slug] = game;
  return result;
}, {});
